import React, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import InfoSvg from '../UI/infoSvg';
import { ToggleExpireModal } from '../../../actions/utils';
import { bindActionCreators } from 'redux';
import { NewBookingQuote } from '../../../actions/booking';
import { withApollo } from 'react-apollo';
import ButtonSpinner from '../../shared/UI/button-spinner';
import { hasPlannerItem } from '../../../helpers/itemsHelper';
import cookie from "js-cookie";
const queryString = require('query-string');

ReactModal.setAppElement('#root');

const ExpireModal = (props) => {

    const isAP = hasPlannerItem(props.currentBookingItems);
    const [showModal, setShowModal] = useState(false);

    const openModal = () => { setShowModal(true); }
    const closeModal = () => {
        setShowModal(false);
        props.ToggleExpireModal(false);
    }

    const onRefresh = () => {
   
       const { client, isLoading } = props;
       const { id } = queryString.parse(window.location.search);
       const token = cookie.get("ap.token");
 
        if(!isLoading){
            NewBookingQuote(client, id).then(() =>{ 

                window.location.href = isAP ? 
                `${process.env.REACT_APP_PLANNER_URL}${process.env.REACT_APP_ITINERARY_PAGE}?id=${id}&t=${token}`: 
                `${process.env.REACT_APP_BOOKING_URL}${process.env.REACT_APP_CART_PAGE}?id=${id}&t=${token}`

                closeModal();
            });
        }

    }

    useEffect(() => {
        if(props.expiredModalIsOpen) openModal();
    });

    

    return (
        <ReactModal
            className="include-modal basket"
            overlayClassName="modal-overlay white"
            isOpen={showModal}
            contentLabel="Include modal">
        
            <div className="max-width-5 mx-auto clearfix">
                <div className="col col-12 center">

                    <InfoSvg />

                    <h4 className="mb1 mt2 black-text">Booking Expired</h4>
                    <p className="medium mt2 mb3 black-text">We’re afraid your booking is no longer active. Please try refresh to hold the booking again with the same dates.</p>
                    <button type="submit" className="busabout--cta orange rounded-corner inline" onClick={onRefresh} disabled={props.isLoading} style={{"width":"210px"}}>
                        { !props.isLoading && <>Refresh booking</> }
                        { props.isLoading &&  <ButtonSpinner  clazz={"white"} /> } 
                    </button>

                    <a href={`${isAP ? `${process.env.REACT_APP_PLANNER_URL}` : `${process.env.REACT_APP_BOOKING_URL}${process.env.REACT_APP_TRIPS_PAGE}` }`} className="orange-text block mt2 f-size-14">Make a new booking</a>
                    
                </div>
            </div>
        </ReactModal>                      
    )
}

const mapStateToProps = state => {
    return{
        expiredModalIsOpen:state.toggleModal.expiredModalIsOpen,
        isLoading:state.cart.update_sector_loading,
        currentBookingItems:state.currentBooking.items
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        ToggleExpireModal
    }, dispatch);
}

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(ExpireModal));